/*
 * JoMuh: Predictive-Search (Dropdown) zusaetzlich nach Artikelnummer (SKU)
 * und EAN/Barcode durchsuchen lassen.
 *
 * Horizon baut den Predictive-Search-Request in assets/predictive-search.js
 * ueber sectionRenderer.getSectionHTML() -> fetch('/search/suggest?...&section_id=predictive-search').
 * Die Ajax-Predictive-Search durchsucht standardmaessig NUR
 * title, product_type, variants.title, vendor (kein SKU/Barcode), deshalb
 * blieb das Dropdown bei Eingabe einer Artikelnummer leer.
 *
 * Wir haengen resources[options][fields] mit den Standardfeldern PLUS
 * variants.sku + variants.barcode an genau diesen Request an. Andere
 * fetch-Requests bleiben unangetastet (enge URL-Pruefung + Idempotenz-Guard).
 *
 * Die normale Ergebnisseite (/search) durchsucht SKU/Barcode bereits per
 * Default; dort genuegt das hidden-Input options[fields] in snippets/search.liquid.
 */
(function () {
  if (window.__jomuhSkuSearchPatched) return;
  window.__jomuhSkuSearchPatched = true;

  var FIELDS = 'title,product_type,variants.title,vendor,variants.sku,variants.barcode';
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (
        url &&
        url.indexOf('/search/suggest') !== -1 &&
        url.indexOf('section_id=predictive-search') !== -1 &&
        url.indexOf('resources[options][fields]') === -1
      ) {
        var patched =
          url +
          (url.indexOf('?') === -1 ? '?' : '&') +
          'resources[options][fields]=' +
          encodeURIComponent(FIELDS);
        if (typeof input === 'string') {
          input = patched;
        } else {
          input = new Request(patched, input);
        }
      }
    } catch (e) {
      /* JoMuh: im Fehlerfall Request unveraendert weiterreichen */
    }
    return nativeFetch.call(this, input, init);
  };
})();
